import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./about-upsc.module.css";
import Syllabus from "../upsc/pre-syllabus";
import upscWebBanner from "../../assets/images/upsc/about-upsc.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Exam from "../upsc/pre-exam";
import Structure from "../upsc/pre-structure";
import Booklist from "../upsc/pre-booklist";
import Interest from '../../components/might-be-interest';
import Link from 'next/link';

const About_Civil_Service = () => {
   
  return (
    <>
              <Head>
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>About Civil Service | Shankar IAS Academy</title>
                <meta name="title" content="About Civil Service | Shankar IAS Academy" />
                <meta name="description" content="Prepare for Civil Service exams with Shankar IAS Academy. Tailored programs, expert mentors, and unwavering support." />
                <link rel="canonical" href="https://www.shankariasacademy.com/about-upsc/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="About Civil Service | Shankar IAS Academy" />
                <meta property="og:description" content="Prepare for Civil Service exams with Shankar IAS Academy. Tailored programs, expert mentors, and unwavering support." />
                <meta property="og:url" content="https://www.shankariasacademy.com/about-upsc/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>
    
    <Navbar title="upsc" />

    <div className="container">
        <div className="row pt-3 pt-md-4">
            <div className="col-md-6 col-12">
            <h1 className={`${styles.pagemaintitle}`}>About Civil Service</h1>
            </div>
            <div className="col-md-6 col-12 align-self-center text-md-end">
            <p className={`${styles.redunderline} mb-0`} style={{textDecoration: "underline"}}><Link href="/about-forestry" className={`${styles.redunderlinealink}`}>Learn about Forest Service</Link></p>
            </div>
        </div>
        </div>


   <div className="container pt-3 pt-md-2">
        <div className="row">
            <div className="col">

                <div className="row">
                    <div className="col">
                        <Image src={upscWebBanner} className="img-fluid w-100" alt="Civil service exam" title="Civil service exam"/>
                    </div>
                </div>
            </div>
        </div>
   </div>

   <div className="container pt-3">
        <div className="row">
          <div className="col">
      
            <div className={`${styles.tabscrollclass} nav nav-pills mb-3  align-items-baseline`}>
                <button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 active" data-bs-toggle="pill" data-bs-target="#centre-1" type="button" role="tab" aria-controls="centre-1" aria-selected="true">About the Exam</button>
                <button id={styles.tablinks} className="nav-link tab2 py-2 px-0 me-4 " data-bs-toggle="pill" data-bs-target="#centre-2" type="button" role="tab" aria-controls="centre-2" aria-selected="false">Exam structure</button>
                {/* <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-3" type="button" role="tab" aria-controls="centre-3" aria-selected="false">Syllabus</button> */}
                <button id={styles.tablinks} className="nav-link py-2 px-0 me-4" data-bs-toggle="pill" data-bs-target="#centre-4" type="button" role="tab" aria-controls="centre-4" aria-selected="false">Book list</button>
            </div>
      
          </div>
        </div>
      </div>


      <div className="tab-content">

        {/* About The Exam Section Start*/}
        <div className="tab-pane active" id="centre-1">
           <Exam />
        </div>
        {/*About The Exam End*/}
       
        {/* Exam Structure Start */}
        <div className="tab-pane" id="centre-2">
            <Structure />
        </div>
        {/*Exam structure end */}
       
        {/*Syllabus Section Start 
        <div className="tab-pane" id="centre-3">
           <Syllabus/>
        </div>*/}
        
        {/*Syllabus Section End */}
           
      {/*Booklist Section Start */}
      <div className="tab-pane" id="centre-4">
          <Booklist />
      </div>
      {/*Booklist Section End */}
          
</div>


    <Interest />
    <Footer />
    </>
  )
}

export default About_Civil_Service;